module.exports = __webpack_public_path__ + "img/tr-tr.ad65bfb8.svg";